import script from "./NoticeDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticeDetailView.vue?vue&type=script&setup=true&lang=js"

import "./NoticeDetailView.vue?vue&type=style&index=0&id=76f50020&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76f50020"]])

export default __exports__